import React from 'react'
import actions from 'redux/actions'
import { useEffect, useInterval, useRef, useMemo } from 'sb-hooks'
import cx from 'classnames'

import Text from 'components/_new/typography/Text/Text'


const getUniqueId = ((id) => () => String(++id))(1)

const getDoubleDigitNumber = (number) => number < 10 ? `0${number}` : number

const getFormattedTime = (timeLeft) => {
  const hours  = getDoubleDigitNumber(Math.floor(timeLeft / 60 / 60 / 1000))
  const mins   = getDoubleDigitNumber(Math.floor((timeLeft / 60 / 1000) % 60))
  const secs   = getDoubleDigitNumber(Math.floor((timeLeft / 1000) % 60))

  return `${hours}:${mins}:${secs}`
}

const Countdown = ({ className, timeLeft, brandColor }) => {
  const countdownId = `countdown${getUniqueId()}`
  const totalTime = useRef(timeLeft)
  const countdownRef = useRef()

  useEffect(() => {
    if (document && document.getElementById) {
      countdownRef.current = document.getElementById(countdownId)
    }
  })

  useInterval((intervalId) => {
    totalTime.current -= 1000

    if (totalTime.current < 0) {
      clearInterval(intervalId)
      actions.view.flashSaleBundlePage.setExpired()
    }
    else if (countdownRef.current) {
      const hours  = getDoubleDigitNumber(Math.floor(totalTime.current / 60 / 60 / 1000))
      const mins   = getDoubleDigitNumber(Math.floor((totalTime.current / 60 / 1000) % 60))
      const secs   = getDoubleDigitNumber(Math.floor((totalTime.current / 1000) % 60))

      countdownRef.current.innerHTML = `${hours}:${mins}:${secs}`
    }
  }, 1000)

  const message = useMemo(() => getFormattedTime(timeLeft), [ timeLeft ])

  return (
    <Text className={cx(className, { 'brandColor': brandColor })} message={message} tag="span" size="32-40" semibold html id={countdownId} />
  )
}


export default Countdown
